// Appedn the Input to the product form 

// document.addEventListener('DOMContentLoaded', function() {
//     console.log('DOM fully loaded and parsed');
//     const variantOption = document.querySelector('.variant__option');
//     // console.log('selectDiv found:', selectDiv);
//     console.log('variantOption found:', variantOption);
//     if (variantOption) {
//         console.log('Both elements found, proceeding with modifications');
//         console.log('Hidden input appended to selectDiv');
        
//         // Replace the radio button content
//         variantOption.innerHTML = '<input type="hidden" name="items[0][id]" value="31897838190653">  <input type="hidden"  name="items[1][id]" value="39408607854653" checked="">';
//         console.log('variantOption content replaced with hidden input');
        
//         // Verify the changes
//         console.log('Current variantOption HTML:', variantOption.innerHTML);
//     } else {
//         // console.error('One or more elements not found:');
//         // if (!selectDiv) console.error('selectDiv not found');
//         if (!variantOption) console.error('variantOption not found');
//     }
// });



// replace the input properties
// document.addEventListener('DOMContentLoaded', function() {
//     // Function to update targeted inputs within hulkapps_product_options
//     function updateHulkAppsInputs() {
//         // Find the main hulkapps container
//         const hulkAppsContainer = document.querySelector('.hulkapps_product_options');
//         if (!hulkAppsContainer) {
//             console.log('HulkApps product options container not found');
//             return;
//         }
//         // List of all input update operations within the container
//         const updateOperations = [
//             {
//                 selector: 'input.hulk_swatch_hidden_prop[name^="properties"]',
//                 transform: (name) => name.replace('properties', 'items[0][properties]'),
//                 type: 'Properties hidden inputs'
//             },
//             {
//                 selector: 'input.swatch_radio[name^="hulk_swatch_"]',
//                 transform: (name, element) => {
//                     // Find the parent option container and get the option name
//                     const optionContainer = element.closest('.hulkapps_option');
//                     if (optionContainer) {
//                         const optionNameElement = optionContainer.querySelector('.hulkapps_option_name');
//                         if (optionNameElement) {
//                             // Extract just the text content (remove the * and tooltip)
//                             const optionName = optionNameElement.childNodes[0].textContent.trim();
//                             return `items[0][properties][${optionName}]`;
//                         }
//                     }
//                     // Fallback: use the numeric ID
//                     const dynamicPart = name.replace('hulk_swatch_', '');
//                     return `items[0][properties][${dynamicPart}]`;
//                 },
//                 type: 'Radio swatch inputs'
//             }
//         ];
        
//         let totalUpdated = 0;
        
//         updateOperations.forEach(operation => {
//             // Only search within the hulkapps container
//             const elements = hulkAppsContainer.querySelectorAll(operation.selector);
//             // console.log(`${operation.type} found:`, elements.length);
            
//             elements.forEach((element, index) => {
//                 if (operation.transform && element.hasAttribute('name')) {
//                     // For inputs that need name transformation
//                     const currentName = element.getAttribute('name');
//                     const newName = operation.transform(currentName, element);
                    
//                     // Only update if the name would change
//                     if (currentName !== newName) {
//                         // console.log(`${operation.type} ${index + 1} - Current:`, currentName);
//                         element.setAttribute('name', newName);
//                         // console.log(`${operation.type} ${index + 1} - Updated to:`, newName);
//                         totalUpdated++;
//                     }
//                 } else if (operation.action) {
//                     // For elements that need removal or other actions
//                     // console.log(`${operation.type} ${index + 1} - Performing action`);
//                     operation.action(element);
//                     totalUpdated++;
//                 }
//             });
//         });
        
//         // console.log(`Total elements processed in HulkApps container: ${totalUpdated}`);
        
//         // Final verification
//         setTimeout(() => {
//             // console.log('=== FINAL VERIFICATION (HulkApps Only) ===');
            
//             // Check properties inputs
//             const updatedProperties = hulkAppsContainer.querySelectorAll('input.hulk_swatch_hidden_prop[name^="items[0][properties]"]');
//             // console.log('Updated properties inputs:', updatedProperties.length);
            
//             // Check radio inputs - now they should have descriptive names
//             const updatedRadios = hulkAppsContainer.querySelectorAll('input.swatch_radio[name^="items[0][properties]["]');
//             // console.log('Updated radio inputs:', updatedRadios.length);
            
//             updatedRadios.forEach((radio, index) => {
//                 // console.log(`Radio input ${index + 1}:`, radio.getAttribute('name'));
//             });
            
//         }, 150);
//     }
    
//     // Run immediately
//     updateHulkAppsInputs();
    
//     // More targeted MutationObserver for hulkapps content
//     const observer = new MutationObserver(function(mutations) {
//         let needsUpdate = false;
        
//         for (let mutation of mutations) {
//             // Check if changes occurred within the hulkapps container
//             const isInHulkAppsContainer = mutation.target.closest && 
//                 (mutation.target.closest('.hulkapps_product_options') || 
//                  mutation.target.matches('.hulkapps_product_options'));
            
//             if (!isInHulkAppsContainer) continue;
            
//             if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
//                 // Check if any relevant elements were added
//                 mutation.addedNodes.forEach(node => {
//                     if (node.nodeType === 1) {
//                         if (node.matches && (
//                             node.matches('input, .hulkapps_option_value') ||
//                             node.querySelector('input, .hulkapps_option_value')
//                         )) {
//                             needsUpdate = true;
//                         }
//                     }
//                 });
//             }
            
//             if (mutation.type === 'attributes') {
//                 // If any attributes change on input elements, update
//                 if (mutation.target.matches && mutation.target.matches('input')) {
//                     needsUpdate = true;
//                 }
//             }
//         }
        
//         if (needsUpdate) {
//             // console.log('🔄 HulkApps DOM updated - running targeted input updates...');
//             // Use setTimeout to ensure DOM is fully updated
//             setTimeout(updateHulkAppsInputs, 50);
//         }
//     });
    
//     // Start observing with targeted scope - only the hulkapps container
//     const hulkAppsContainer = document.querySelector('.hulkapps_product_options');
//     if (hulkAppsContainer) {
//         observer.observe(hulkAppsContainer, {
//             childList: true,
//             subtree: true,
//             attributes: true,
//             attributeFilter: ['name', 'class', 'type', 'value', 'style']
//         });
        
//         // console.log('✅ Targeted HulkApps input updater with MutationObserver is active');
//     } else {
//         // console.log('❌ HulkApps container not found for MutationObserver');
//     }
    
//     // Additional: Also check when the HulkApps options are likely loaded
//     if (document.getElementById('hulkapps_option_list_38256012')) {
//         // console.log('HulkApps options container found, running additional check...');
//         setTimeout(updateHulkAppsInputs, 500);
//     }
    
//     // Backup: Check again after a short delay in case of slow loading
//     setTimeout(updateHulkAppsInputs, 1000);
//     setTimeout(updateHulkAppsInputs, 3000);
// });

// clonme the color swatch
// function waitForElements() {
//     // Source: the element with actual content
//     const sourceElement = document.getElementById('hulkapps_option_list_38256012');
//     // Target: your empty div
//     const targetDiv = document.getElementById('hulkapps_custom_options');
    
//     // console.log("📝 Checking elements status:");
//     // console.log("- Source element found:", !!sourceElement);
//     // console.log("- Target div found:", !!targetDiv);
    
//     if (sourceElement && targetDiv) {
//         // console.log("✅ Both elements found! Starting clone operation...");
//         // console.log("📦 Source element content:", sourceElement.innerHTML);
//         // console.log("🎯 Target div before append:", targetDiv.innerHTML);
        
//         try {
//             // Clone the element with all its children
//             const clonedHtml = sourceElement.cloneNode(true);
//             // console.log("📋 Element cloned successfully");
            
//             // Clear target div first (optional)
//             targetDiv.innerHTML = '';
            
//             // Append to target
//             targetDiv.appendChild(clonedHtml);
//             // console.log("✅ Element cloned and appended successfully");
//             // console.log("🎯 Target div after append:", targetDiv.innerHTML);
            
//             // Verify the operation
//             const hasContent = targetDiv.innerHTML.length > 0;
//             // console.log("🔍 Verification - target has content:", hasContent);
            
//         } catch (error) {
//             // console.error("❌ Error during clone/append operation:", error);
//         }
        
//     } else {
//         // console.log("⏳ Elements not yet available, waiting...");
        
//         // Add timeout to prevent infinite loop
//         if (typeof waitForElements.attempts === 'undefined') {
//             waitForElements.attempts = 0;
//         }
//         waitForElements.attempts++;
        
//         // console.log(`🔄 Attempt number: ${waitForElements.attempts}`);
        
//         // Stop after 50 attempts (5 seconds)
//         if (waitForElements.attempts < 100) {
//             setTimeout(waitForElements, 100);
//         } else {
//             // console.error("❌ Timeout: Elements not found after 5 seconds");
//             // console.log("🔍 Debug info - current hulkapps elements:");
//             const hulkappsElements = document.querySelectorAll('[id*="hulkapps"]');
//             hulkappsElements.forEach(el => {
//                 // console.log(`Hulkapps element: ${el.id} | Has content: ${el.innerHTML.length > 0}`);
//             });
//         }
//     }
// }
// waitForElements();
// document.addEventListener('DOMContentLoaded', function() {
//     // console.log("📄 DOMContentLoaded event fired");
//     waitForElements();
// });
// window.addEventListener('load', function() {
//     // console.log("🖼️ Window load event fired");
//     waitForElements();
// });
// // console.log("👀 Script loaded and waiting for elements...");


// // update the clone inputs names

// document.addEventListener('DOMContentLoaded', function() {
//     // console.log('DOM fully loaded and parsed');
    
//     // Function to update ONLY hulkapps_custom_options inputs
//     function updateHulkAppsInputs() {
//         // Target only inputs inside #hulkapps_custom_options
//         const updateOperations = [
//             {
//                 selector: '#hulkapps_custom_options input[name^="items[0][properties]["]',
//                 transform: (name, element) => {
//                     // Extract the property name from the current name
//                     const match = name.match(/items\[0\]\[properties\]\[([^\]]+)\]/);
//                     if (match && match[1]) {
//                         const currentPropertyName = match[1];
                        
//                         // Find the parent option container and get the dynamic option name
//                         const optionContainer = element.closest('.hulkapps_option');
//                         if (optionContainer) {
//                             const optionNameElement = optionContainer.querySelector('.hulkapps_option_name');
//                             if (optionNameElement) {
//                                 // Extract just the text content (remove the * and tooltip)
//                                 const optionName = optionNameElement.childNodes[0].textContent.trim();
                                
//                                 // Use the actual option name dynamically
//                                 return `items[1][properties][${optionName}]`;
//                             }
//                         }
                        
//                         // Fallback: use the current property name
//                         return `items[1][properties][${currentPropertyName}]`;
//                     }
//                     return name;
//                 },
//                 type: 'HulkApps custom options inputs (dynamic names)'
//             },
//             // Also handle inputs that might already be in items[1] format but need dynamic names
//             {
//                 selector: '#hulkapps_custom_options input[name^="items[1][properties]["]',
//                 transform: (name, element) => {
//                     // Extract the property name from the current name
//                     const match = name.match(/items\[1\]\[properties\]\[([^\]]+)\]/);
//                     if (match && match[1]) {
//                         const currentPropertyName = match[1];
                        
//                         // Find the parent option container and get the dynamic option name
//                         const optionContainer = element.closest('.hulkapps_option');
//                         if (optionContainer) {
//                             const optionNameElement = optionContainer.querySelector('.hulkapps_option_name');
//                             if (optionNameElement) {
//                                 // Extract just the text content (remove the * and tooltip)
//                                 const optionName = optionNameElement.childNodes[0].textContent.trim();
                                
//                                 // Only update if the names are different
//                                 if (currentPropertyName !== optionName) {
//                                     return `items[1][properties][${optionName}]`;
//                                 }
//                             }
//                         }
//                     }
//                     return name;
//                 },
//                 type: 'HulkApps custom options inputs (update existing items[1] names)'
//             }
//         ];
        
//         let totalUpdated = 0;
        
//         updateOperations.forEach(operation => {
//             const elements = document.querySelectorAll(operation.selector);
//             // console.log(`${operation.type} found:`, elements.length);
            
//             elements.forEach((element, index) => {
//                 if (operation.transform && element.hasAttribute('name')) {
//                     const currentName = element.getAttribute('name');
//                     const newName = operation.transform(currentName, element);
                    
//                     if (currentName !== newName) {
//                         // console.log(`${operation.type} ${index + 1} - Current:`, currentName);
//                         element.setAttribute('name', newName);
//                         // console.log(`${operation.type} ${index + 1} - Updated to:`, newName);
//                         totalUpdated++;
//                     }
//                 }
//             });
//         });
        
//         // console.log(`Total HulkApps elements processed: ${totalUpdated}`);
        
//         // Final verification - show all dynamic names
//         setTimeout(() => {
//             // console.log('=== FINAL VERIFICATION ===');
            
//             // Get all option names to show what's available
//             const optionNames = document.querySelectorAll('#hulkapps_custom_options .hulkapps_option_name');
//             // console.log('Available option names:', optionNames.length);
            
//             optionNames.forEach((optionNameEl, index) => {
//                 const optionName = optionNameEl.childNodes[0].textContent.trim();
//                 // console.log(`Option ${index + 1}: "${optionName}"`);
//             });
            
//             // Show all updated inputs
//             const updatedInputs = document.querySelectorAll('#hulkapps_custom_options input[name^="items[1][properties]["]');
//             // console.log('All updated HulkApps inputs:', updatedInputs.length);
            
//             updatedInputs.forEach((input, index) => {
//                 // console.log(`Input ${index + 1}:`, input.getAttribute('name'));
//             });
            
//         }, 150);
//     }
    
//     // Run immediately
//     updateHulkAppsInputs();
    
//     // Enhanced MutationObserver for dynamic content
//     const observer = new MutationObserver(function(mutations) {
//         let needsUpdate = false;
        
//         for (let mutation of mutations) {
//             if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
//                 mutation.addedNodes.forEach(node => {
//                     if (node.nodeType === 1) {
//                         // Check if any relevant elements were added
//                         if (node.matches && (
//                             node.matches('#hulkapps_custom_options, .hulkapps_option, .hulkapps_option_name, input') ||
//                             node.querySelector('#hulkapps_custom_options, .hulkapps_option, .hulkapps_option_name, input')
//                         )) {
//                             needsUpdate = true;
//                         }
//                     }
//                 });
//             }
            
//             if (mutation.type === 'attributes') {
//                 // If name attribute changes or option names are updated
//                 if (mutation.target.matches && 
//                     (mutation.target.matches('#hulkapps_custom_options input') || 
//                      mutation.target.matches('.hulkapps_option_name')) && 
//                     mutation.attributeName === 'name') {
//                     needsUpdate = true;
//                 }
//             }
            
//             // Also update if text content of option names changes
//             if (mutation.type === 'characterData' || mutation.type === 'childList') {
//                 if (mutation.target && 
//                     (mutation.target.parentElement?.classList?.contains('hulkapps_option_name') || 
//                      mutation.target.classList?.contains('hulkapps_option_name'))) {
//                     needsUpdate = true;
//                 }
//             }
//         }
        
//         if (needsUpdate) {
//             // console.log('🔄 HulkApps content changed - updating dynamic input names...');
//             setTimeout(updateHulkAppsInputs, 50);
//         }
//     });
    
//     // Start observing the hulkapps container and its contents
//     const hulkAppsContainer = document.getElementById('hulkapps_custom_options');
//     if (hulkAppsContainer) {
//         observer.observe(hulkAppsContainer, {
//             childList: true,
//             subtree: true,
//             attributes: true,
//             attributeFilter: ['name', 'class'],
//             characterData: true
//         });
//         // console.log('✅ Dynamic HulkApps input updater is active');
//     } else {
//         // console.log('❌ HulkApps container not found initially, will retry...');
//         // Retry after a delay if container not found initially
//         setTimeout(() => {
//             const retryContainer = document.getElementById('hulkapps_custom_options');
//             if (retryContainer) {
//                 observer.observe(retryContainer, {
//                     childList: true,
//                     subtree: true,
//                     attributes: true,
//                     attributeFilter: ['name', 'class'],
//                     characterData: true
//                 });
//                 // console.log('✅ Dynamic HulkApps input updater activated on retry');
//                 updateHulkAppsInputs();
//             }
//         }, 1000);
//     }
    
//     // Additional checks for dynamic loading
//     setTimeout(updateHulkAppsInputs, 500);
//     setTimeout(updateHulkAppsInputs, 1000);
//     setTimeout(updateHulkAppsInputs, 3000);
    
//     // Also observe the entire body for the initial appearance of hulkapps container
//     const bodyObserver = new MutationObserver(function(mutations) {
//         for (let mutation of mutations) {
//             if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
//                 mutation.addedNodes.forEach(node => {
//                     if (node.nodeType === 1 && 
//                         (node.id === 'hulkapps_custom_options' || 
//                          node.querySelector('#hulkapps_custom_options'))) {
//                         // console.log('🎯 HulkApps container appeared in DOM');
//                         setTimeout(updateHulkAppsInputs, 100);
//                     }
//                 });
//             }
//         }
//     });
    
//     bodyObserver.observe(document.body, {
//         childList: true,
//         subtree: true
//     });
// });

// // append the quanity selector

// document.addEventListener('DOMContentLoaded', function() {
//     const quantityElement = document.querySelector('.quantity');
//     const variationWrap = document.querySelector('.single_variation_wrap');

//     // console.log('DOM loaded - Quantity element found:', quantityElement);
//     // console.log('DOM loaded - Variation wrap found:', variationWrap);

//     if (quantityElement && variationWrap) {
//         // console.log('Both elements exist, proceeding with clone...');
        
//         // Clone with all child elements and their data
//         const clonedQuantity = quantityElement.cloneNode(true);
//         // console.log('Quantity cloned successfully:', clonedQuantity);
        
//         // Append to the variation wrap
//         variationWrap.appendChild(clonedQuantity);
//         // console.log('Cloned quantity appended to variation wrap');
        
//         // Optional: Add a class to identify the cloned element
//         clonedQuantity.classList.add('cloned-quantity');
//         clonedQuantity.classList.add('hidden');
//         // console.log('Added "cloned-quantity" class to cloned element');
        
//         // console.log('Clone operation completed successfully!');
//     } else {
//         console.warn('Cannot clone: One or both elements not found');
//         if (!quantityElement) {
//             // console.error('Quantity element (.quantity) not found');
//         }
//         if (!variationWrap) {
//             // console.error('Variation wrap (.single_variation_wrap) not found');
//         }
//     }
// });

// // Update the name properties to quantity input

// document.addEventListener('DOMContentLoaded', function() {
//     const inputs = document.querySelectorAll('input[name="quantity"]');
//         inputs.forEach(input => {
//             input.name = 'items[0][quantity]';
//         });
//     console.log('Name updated successfully for ' + inputs.length + ' input(s)');
// });

// // Update the clone input name 

// document.addEventListener('DOMContentLoaded', function() {
//     const inputs = document.querySelectorAll('.cloned-quantity input[name="items[0][quantity]"]');
//     // console.log("Found inputs:", inputs.length);
    
//     inputs.forEach(input => {
//         input.name = 'items[1][quantity]';
//     });
    
//     // console.log('Name updated successfully for ' + inputs.length + ' input(s)');
// });


// // Update the text inputs name atribute

// // Function to convert property name to lowercase format
// function convertToDynamicName(originalName) {
//   // Remove 'properties[' and ']' then convert to lowercase
//   const propertyName = originalName.replace('properties[', '').replace(']', '');
//   const dynamicName = `items[0][properties][${propertyName.toLowerCase()}]`;
//     //   console.log(`  🔤 Name conversion: ${originalName} → ${dynamicName}`);
//   return dynamicName;
// }

// // Function to update input names within embroidery elements
// function updateEmbroideryInputNames() {
//     //   console.log('🔄 updateEmbroideryInputNames() called');
  
//     const embroideryElements = document.querySelectorAll('.embroidery');
//     //   console.log(`📦 Found ${embroideryElements.length} embroidery elements`);
  
//   let totalInputsUpdated = 0;
  
//   embroideryElements.forEach((embroidery, index) => {
//     // console.log(`🎯 Processing embroidery element ${index + 1}`);
    
//     // Find all inputs within embroidery that have properties[] names
//     const allInputs = embroidery.querySelectorAll('input[name^="properties["]');
//     // console.log(`  🔍 Found ${allInputs.length} total property inputs`);
    
//     // Process each input individually
//     allInputs.forEach(input => {
//       const oldName = input.name;
      
//       // Skip if already converted
//       if (oldName.startsWith('items[0][properties]')) {
//         // console.log(`    ⏭️  Already converted: ${oldName}`);
//         return;
//       }
      
//       // Convert to dynamic lowercase name
//       const newName = convertToDynamicName(oldName);
//       input.name = newName;
//     //   console.log(`    ✅ Updated: ${oldName} → ${newName}`);
//       totalInputsUpdated++;
//     });
//   });
  
//     //   console.log(`🎉 Total inputs updated: ${totalInputsUpdated}`);
//   return totalInputsUpdated;
// }

// // Function to initialize the observers
// function initObservers() {
//     //   console.log('🚀 Starting initial embroidery input name update...');
//     const initialUpdates = updateEmbroideryInputNames();
//     //   console.log(`🏁 Initial update completed. Updated ${initialUpdates} inputs`);

//     // Set up MutationObserver to handle dynamically added elements
//     const observer = new MutationObserver((mutations) => {
//         // console.log('👀 MutationObserver triggered');
//         // console.log(`📋 Processing ${mutations.length} mutations`);
        
//         let shouldUpdate = false;
        
//         mutations.forEach((mutation, index) => {
//         //   console.log(`  🔍 Mutation ${index + 1}: ${mutation.type}`);
        
//         if (mutation.type === 'childList') {
//             // console.log(`    📝 Added nodes: ${mutation.addedNodes.length}, Removed nodes: ${mutation.removedNodes.length}`);
            
//             // Check if any added nodes are embroidery elements or contain them
//             mutation.addedNodes.forEach((node, nodeIndex) => {
//             if (node.nodeType === Node.ELEMENT_NODE) {
//                 if (node.classList && node.classList.contains('embroidery')) {
//                 //   console.log(`    ✅ Found direct .embroidery element in added nodes (index ${nodeIndex})`);
//                 shouldUpdate = true;
//                 } else if (node.querySelector && node.querySelector('.embroidery')) {
//                 //   console.log(`    ✅ Found .embroidery element within added node (index ${nodeIndex})`);
//                 shouldUpdate = true;
//                 }
//             }
//             });
//         }
//         });
        
//         if (shouldUpdate) {
//         //   console.log('🔄 Changes detected, updating embroidery input names...');
//         setTimeout(() => {
//             const dynamicUpdates = updateEmbroideryInputNames();
//             // console.log(`🏁 Dynamic update completed. Updated ${dynamicUpdates} inputs`);
//         }, 100);
//         } else {
//         //   console.log('⏭️  No relevant changes, skipping update');
//         }
//     });

//     // Start observing the document body for added nodes
//     //   console.log('🔭 Starting MutationObserver on document body...');
//     observer.observe(document.body, {
//         childList: true,
//         subtree: true
//     });

//     // Optional: Also observe for attribute changes in case names are changed dynamically
//     const attributeObserver = new MutationObserver((mutations) => {
//         // console.log('👀 Attribute MutationObserver triggered');
//         // console.log(`📋 Processing ${mutations.length} attribute mutations`);
        
//         mutations.forEach((mutation, index) => {
//         if (mutation.type === 'attributes' && mutation.attributeName === 'name') {
//             const target = mutation.target;
//             const oldName = target.getAttribute('name');
//             // console.log(`  🔍 Attribute change ${index + 1}: ${mutation.attributeName} on`, target, `Value: ${oldName}`);
            
//             if (target.closest('.embroidery') && oldName && oldName.startsWith('properties[') && !oldName.startsWith('items[0][properties]')) {
//             //   console.log('  ✅ Attribute change within .embroidery element, scheduling update...');
//             // Re-update names if they get changed back
//             setTimeout(() => {
//                 // console.log('🔄 Executing scheduled update from attribute change...');
//                 const attributeUpdates = updateEmbroideryInputNames();
//                 // console.log(`🏁 Attribute change update completed. Updated ${attributeUpdates} inputs`);
//             }, 0);
//             }
//         }
//         });
//     });

//     //   console.log('🔭 Starting Attribute MutationObserver...');
//     attributeObserver.observe(document.body, {
//         attributes: true,
//         attributeFilter: ['name'],
//         subtree: true
//     });

//     //   console.log('✅ All observers started successfully!');
// }

// // Wait for DOM to be ready
// if (document.readyState === 'loading') {
//   // DOM is still loading, wait for it
//   document.addEventListener('DOMContentLoaded', function() {
//     // console.log('📄 DOM fully loaded, initializing observers...');
//     initObservers();
//   });
// } else {
//   // DOM is already ready
//     //   console.log('📄 DOM already ready, initializing observers...');
//   initObservers();
// }

// // clone the text inputs name atribute

// document.addEventListener('DOMContentLoaded', function() {
//     // Get all embroidery containers
//     const embroideryContainers = document.querySelectorAll('.embroidery');
//     const targetElement = document.querySelector('#hulkapps_custom_text-properties');
    
//     // Add class to the target element itself
//     targetElement.classList.add('clone-text_prooerties');
    
//     // Clone and append each embroidery container
//     embroideryContainers.forEach(container => {
//         const clonedContainer = container.cloneNode(true);
        
//         // Add the clone-embroidery class to the cloned container
//         clonedContainer.classList.add('clone-embroidery');
        
//         targetElement.appendChild(clonedContainer);
//     });
// });

// // Update the cloned input name properties

// document.addEventListener('DOMContentLoaded', function() {
//     function updateInputNames(container, newIndex) {
//         if (!container) {
//             console.log('Container not found');
//             return;
//         }
        
//         const inputs = container.querySelectorAll('input');
        
//         inputs.forEach(input => {
//             const currentName = input.name;
//             // Use regex to find and replace items[0] with items[newIndex]
//             const updatedName = currentName.replace(/items\[\d+\]/g, `items[${newIndex}]`);
//             input.name = updatedName;
//         });
        
//         console.log(`Input names updated to items[${newIndex}]`);
//     }

//     // Usage
//     const container = document.querySelector('.clone-text_prooerties');
//     updateInputNames(container, 1); // Change to items[1]
    
//     // Or for different index:
//     // updateInputNames(container, 2); // Change to items[2]
// });

// // cloned  Text Properties selected

// document.addEventListener('DOMContentLoaded', function() {
//   // Function to handle selection within a specific container
//   function initSelectionContainer(container) {
//     // Get only the radio buttons inside this specific container
//     const containerRadios = container.querySelectorAll('.clone-text_prooerties .clone-embroidery label input[type="radio"]');
    
//     // Create unique group name for this container only
//     const groupName = 'container_group_' + (container.id || Math.random().toString(36).substr(2, 9));
    
//     // Group all radios in this container together
//     containerRadios.forEach(radio => {
//       radio.name = groupName;
//     });
    
//     // Function to update text inputs in this container only
//     function updateContainerTextInputs(selectedRadio) {
//       // Disable all text inputs in this container only
//       const allTextInputs = container.querySelectorAll('.clone-text_prooerties .clone-embroidery label input[type="text"]');
//       allTextInputs.forEach(input => {
//         input.disabled = true;
//       });
      
//       // Enable text inputs for the selected option in this container
//       if (selectedRadio && selectedRadio.checked) {
//         const selectedLabel = selectedRadio.closest('label');
//         if (selectedLabel) {
//           const selectedTextInputs = selectedLabel.querySelectorAll('.clone-text_prooerties .clone-embroidery label input[type="text"]');
//           selectedTextInputs.forEach(input => {
//             input.disabled = false;
//           });
//         }
//       }
//     }
    
//     // Add event listeners only to radios in this container
//     containerRadios.forEach(radio => {
//       radio.addEventListener('change', function() {
//         updateContainerTextInputs(this);
//       });
//     });
    
//     // Initialize text inputs state for this container
//     const containerTextInputs = container.querySelectorAll('input[type="text"]');
//     containerTextInputs.forEach(input => {
//       input.disabled = true;
//     });
    
//     // Check if any radio is selected in this container
//     const checkedRadio = container.querySelector('input[type="radio"]:checked');
//     if (checkedRadio) {
//       updateContainerTextInputs(checkedRadio);
//     }
//   }
  
//   // Find ALL containers with the class and initialize each one
//   const allContainers = document.querySelectorAll('.clone-text_prooerties');
//   allContainers.forEach(container => {
//     initSelectionContainer(container);
//   });
// });

// // Wait for DOM to be fully loaded
// document.addEventListener('DOMContentLoaded', function() {
//     // Get ALL input elements with the class
//     const inputElements = document.querySelectorAll('.cus-propertie_input');
    
//     // Check if elements were found
//     if (inputElements.length === 0) {
//         console.log('No elements found with class: .cus-propertie_input');
//         return;
//     }
    
//     console.log(`Found ${inputElements.length} input element(s)`);
    
//     // Simple enable function for all inputs
//     function enableAllInputs() {
//         inputElements.forEach(input => {
//             input.disabled = false;
//             input.removeAttribute('disabled');
//             console.log('Enabled input:', input);
//         });
//     }
    
//     // Call to enable all
//     enableAllInputs();
// });

                              
// document.addEventListener('DOMContentLoaded', function() {
//   console.log('DOM fully loaded and parsed');

// // Function to update ONLY hulkapps_custom_options inputs
// function updateHulkAppsInputs() {
//     // Target only inputs inside #hulkapps_custom_options
//     const updateOperations = [
//         {
//             selector: '#hulkapps_custom_options input[name^="items[0][properties]["]',
//             transform: (name, element) => {
//                 // Extract the property name from the current name
//                 const match = name.match(/items\[0\]\[properties\]\[([^\]]+)\]/);
//                 if (match && match[1]) {
//                     const currentPropertyName = match[1];
                    
//                     // Find the parent option container and get the dynamic option name
//                     const optionContainer = element.closest('.hulkapps_option');
//                     if (optionContainer) {
//                         const optionNameElement = optionContainer.querySelector('.hulkapps_option_name');
//                         if (optionNameElement) {
//                             // Extract just the text content (remove the * and tooltip)
//                             const optionName = optionNameElement.childNodes[0].textContent.trim();
                            
//                             // Use the actual option name dynamically
//                             return `items[1][properties][${optionName}]`;
//                         }
//                     }
                    
//                     // Fallback: use the current property name
//                     return `items[1][properties][${currentPropertyName}]`;
//                 }
//                 return name;
//             },
//             type: 'HulkApps custom options inputs (dynamic names)'
//         },
//         // Also handle inputs that might already be in items[1] format but need dynamic names
//         {
//             selector: '#hulkapps_custom_options input[name^="items[1][properties]["]',
//             transform: (name, element) => {
//                 // Extract the property name from the current name
//                 const match = name.match(/items\[1\]\[properties\]\[([^\]]+)\]/);
//                 if (match && match[1]) {
//                     const currentPropertyName = match[1];
                    
//                     // Find the parent option container and get the dynamic option name
//                     const optionContainer = element.closest('.hulkapps_option');
//                     if (optionContainer) {
//                         const optionNameElement = optionContainer.querySelector('.hulkapps_option_name');
//                         if (optionNameElement) {
//                             // Extract just the text content (remove the * and tooltip)
//                             const optionName = optionNameElement.childNodes[0].textContent.trim();
                            
//                             // Only update if the names are different
//                             if (currentPropertyName !== optionName) {
//                                 return `items[1][properties][${optionName}]`;
//                             }
//                         }
//                     }
//                 }
//                 return name;
//             },
//             type: 'HulkApps custom options inputs (update existing items[1] names)'
//         }
//     ];
    
//     let totalUpdated = 0;
    
//     updateOperations.forEach(operation => {
//         const elements = document.querySelectorAll(operation.selector);
//         // console.log(`${operation.type} found:`, elements.length);
        
//         elements.forEach((element, index) => {
//             if (operation.transform && element.hasAttribute('name')) {
//                 const currentName = element.getAttribute('name');
//                 const newName = operation.transform(currentName, element);
                
//                 if (currentName !== newName) {
//                     // console.log(`${operation.type} ${index + 1} - Current:`, currentName);
//                     element.setAttribute('name', newName);
//                     // console.log(`${operation.type} ${index + 1} - Updated to:`, newName);
//                     totalUpdated++;
//                 }
//             }
//         });
//     });
    
//     // console.log(`Total HulkApps elements processed: ${totalUpdated}`);
    
//     // Final verification - show all dynamic names
//     setTimeout(() => {
//         // console.log('=== FINAL VERIFICATION ===');
        
//         // Get all option names to show what's available
//         const optionNames = document.querySelectorAll('#hulkapps_custom_options .hulkapps_option_name');
//         // console.log('Available option names:', optionNames.length);
        
//         optionNames.forEach((optionNameEl, index) => {
//             const optionName = optionNameEl.childNodes[0].textContent.trim();
//             // console.log(`Option ${index + 1}: "${optionName}"`);
//         });
        
//         // Show all updated inputs
//         const updatedInputs = document.querySelectorAll('#hulkapps_custom_options input[name^="items[1][properties]["]');
//         // console.log('All updated HulkApps inputs:', updatedInputs.length);
        
//         updatedInputs.forEach((input, index) => {
//             // console.log(`Input ${index + 1}:`, input.getAttribute('name'));
//         });
        
//     }, 150);
// }

// // Run immediately
// updateHulkAppsInputs();

// // Enhanced MutationObserver for dynamic content
// const observer = new MutationObserver(function(mutations) {
//     let needsUpdate = false;
    
//     for (let mutation of mutations) {
//         if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
//             mutation.addedNodes.forEach(node => {
//                 if (node.nodeType === 1) {
//                     // Check if any relevant elements were added
//                     if (node.matches && (
//                         node.matches('#hulkapps_custom_options, .hulkapps_option, .hulkapps_option_name, input') ||
//                         node.querySelector('#hulkapps_custom_options, .hulkapps_option, .hulkapps_option_name, input')
//                     )) {
//                         needsUpdate = true;
//                     }
//                 }
//             });
//         }
        
//         if (mutation.type === 'attributes') {
//             // If name attribute changes or option names are updated
//             if (mutation.target.matches && 
//                 (mutation.target.matches('#hulkapps_custom_options input') || 
//                 mutation.target.matches('.hulkapps_option_name')) && 
//                 mutation.attributeName === 'name') {
//                 needsUpdate = true;
//             }
//         }
        
//         // Also update if text content of option names changes
//         if (mutation.type === 'characterData' || mutation.type === 'childList') {
//             if (mutation.target && 
//                 (mutation.target.parentElement?.classList?.contains('hulkapps_option_name') || 
//                 mutation.target.classList?.contains('hulkapps_option_name'))) {
//                 needsUpdate = true;
//             }
//         }
//     }
    
//     if (needsUpdate) {
//         // console.log('🔄 HulkApps content changed - updating dynamic input names...');
//         setTimeout(updateHulkAppsInputs, 50);
//     }
// });

// // Start observing the hulkapps container and its contents
// const hulkAppsContainer = document.getElementById('hulkapps_custom_options');
// if (hulkAppsContainer) {
//     observer.observe(hulkAppsContainer, {
//         childList: true,
//         subtree: true,
//         attributes: true,
//         attributeFilter: ['name', 'class'],
//         characterData: true
//     });
//     // console.log('✅ Dynamic HulkApps input updater is active');
// } else {
//     // console.log('❌ HulkApps container not found initially, will retry...');
//     // Retry after a delay if container not found initially
//     setTimeout(() => {
//         const retryContainer = document.getElementById('hulkapps_custom_options');
//         if (retryContainer) {
//             observer.observe(retryContainer, {
//                 childList: true,
//                 subtree: true,
//                 attributes: true,
//                 attributeFilter: ['name', 'class'],
//                 characterData: true
//             });
//             // console.log('✅ Dynamic HulkApps input updater activated on retry');
//             updateHulkAppsInputs();
//         }
//     }, 1000);
// }

// // Additional checks for dynamic loading
// setTimeout(updateHulkAppsInputs, 500);
// setTimeout(updateHulkAppsInputs, 1000);
// setTimeout(updateHulkAppsInputs, 3000);

// // Also observe the entire body for the initial appearance of hulkapps container
// const bodyObserver = new MutationObserver(function(mutations) {
//     for (let mutation of mutations) {
//         if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
//             mutation.addedNodes.forEach(node => {
//                 if (node.nodeType === 1 && 
//                     (node.id === 'hulkapps_custom_options' || 
//                     node.querySelector('#hulkapps_custom_options'))) {
//                     // console.log('🎯 HulkApps container appeared in DOM');
//                     setTimeout(updateHulkAppsInputs, 100);
//                 }
//             });
//         }
//     }
// });

// bodyObserver.observe(document.body, {
//     childList: true,
//     subtree: true
// });
// }); 

document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(() => {
    document
      .querySelectorAll('.clone-embroidery .Main-cus-propertie_input')
      .forEach(input => input.remove());
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

